import axios from "axios";
import * as API_LINKS from '../../config/links.jsx'
import {toast} from 'react-toastify'
// import { onFetch } from "src/helpers/helper.jsx";

export const FETCH_FUEL_MANAGEMENT_LIST = 'FETCH_FUEL_MANAGEMENT_LIST'
export const RECEIVE_FUEL_MANAGEMENT_LIST = 'RECEIVE_FUEL_MANAGEMENT_LIST'
export const FAILED_FUEL_MANAGEMENT_LIST = 'FAILED_FUEL_MANAGEMENT_LIST'

// const fetchDataNear = ({refill_time, id_fleet, id_saved_place}, cb)=>{
//     onFetch({
//         url: API_LINKS.GET_FLEET_LOG_NEAR_SAVED_PLACE,
//         data: {
//             refill_time,
//             id_fleet,
//             id_saved_place
//         },
//         type:"json"
//     },{
//         beforeSend:() => null,
//         success:(res)=>{
//             cb(false, res.data.result);
//         },
//         error: ()=>{
//             cb(true, null);
//         }
//     })
    
// }

// const getDataNear = (arr, index=0, alteredArr, responseData, dispatch, cb) => {
//     const item = arr[index];
//     let modifiedArr = [...alteredArr];
    
//     if(!!item.id_saved_place){
        
//         fetchDataNear({
//             refill_time: item.refill_time,
//             id_fleet: item.id_fleet,
//             id_saved_place: item.id_saved_place,
//         }, (err, result)=>{

//             modifiedArr = [...modifiedArr.map((dt, i)=> i===index ? ({...dt, near: result}) : dt)];

//             dispatch( {
//                 type: RECEIVE_FUEL_MANAGEMENT_LIST,
//                 payload: {...responseData, result: modifiedArr}
//             })

//             let newIndex = index+1;

//             if(!!arr[newIndex]){
//                 getDataNear(arr, newIndex, modifiedArr, responseData, dispatch, cb);
//             }
//             else{
//                 cb(modifiedArr);
//             }
//         })
//     }
//     else{
//         let newIndex = index+1;

//         modifiedArr = [...modifiedArr.map((dt, i)=> i===index ? ({...dt, near: null}) : dt)];

//         dispatch( {
//             type: RECEIVE_FUEL_MANAGEMENT_LIST,
//             payload: {...responseData, result: modifiedArr}
//         })

//         if(!!arr[newIndex]){
//             getDataNear(arr, newIndex, modifiedArr, responseData, dispatch, cb);
//         }
//         else{
//             cb(modifiedArr);
//         }
//     }
// }

export const fetchFuelDataNear = (id) => (dispatch, getState)=>{


    let auth = getState().authStore.authData.result.token;


    let dt = getState().fuelManagementListStore.fuelManagementListData.find((item)=>item.id===id);

    if(!!dt){



        dispatch( {
            type: RECEIVE_FUEL_MANAGEMENT_LIST,
            payload: { result: getState().fuelManagementListStore.fuelManagementListData.map((item)=>item.id===id?({...item, sensor_data_json: "Loading"}):item)}
        })

        axios({
            method: 'post',
            url: API_LINKS.GET_FLEET_LOG_NEAR_SAVED_PLACE,
            headers: {
                Authorization: auth
            },
            data: {
                refill_time: dt.refill_time,
                id_fleet: dt.id_fleet,
                id_saved_place: dt.id_saved_place,
                id_fuel_refill_track: id
            },
        }).then((response)=>{
            dispatch( {
                type: RECEIVE_FUEL_MANAGEMENT_LIST,
                payload: { result: getState().fuelManagementListStore.fuelManagementListData.map((item)=>item.id===id?({...item, sensor_data_json: response.data.result}):item)}
            })
        }).catch(()=>{
            dispatch( {
                type: RECEIVE_FUEL_MANAGEMENT_LIST,
                payload: { result: getState().fuelManagementListStore.fuelManagementListData.map((item)=>item.id===id?({...item, sensor_data_json: null}):item)}
            })
        })
    }

}

export const fetchFuelManagementList = (_id) => (dispatch, getState) => {
        let auth = getState().authStore.authData.result.token;
        dispatch({type: FETCH_FUEL_MANAGEMENT_LIST});
        axios({
            method: 'post',
            url: API_LINKS.FUEL_MANAGEMENT_LIST,
            headers: {
                Authorization: auth
            },
            data: {
                id_fleet: _id
            }
        })
        .then((response) => {

            let newResult = response.data.result
            // .map((item)=>({...item, near: "Loading"}))
            .sort((a, b)=> new Date(b.refill_time).getTime() - new Date(a.refill_time).getTime())

            dispatch( {
                type: RECEIVE_FUEL_MANAGEMENT_LIST,
                payload: {...response.data, result: newResult.map((item)=>{
                    return {...item, sensor_data_json: !!item.sensor_data_json && item.sensor_data_json!==""?JSON.parse(item.sensor_data_json):null}
                })}
            })

            // Promise.all(newResult.map((item)=>axios({
            //     method: 'post',
            //     url: API_LINKS.GET_FLEET_LOG_NEAR_SAVED_PLACE,
            //     headers: {
            //         Authorization: auth
            //     },
            //     data: {
            //         refill_time:item.refill_time,
            //         id_fleet:item.id_fleet,
            //         id_saved_place:item.id_saved_place
            //     },
            // }).then((resp)=> ({...item, near: resp.data.result})).catch(()=>({...item, near: null})))).then((result)=>{
            //     console.log("=====tes",result)
            //     dispatch( {
            //         type: RECEIVE_FUEL_MANAGEMENT_LIST,
            //         payload: {...response.data, result}
            //     })
            //     // console.log(response.data)
            // })

            

            // getDataNear(
            //     newResult.sort((a, b)=> new Date(b.refill_time).getTime() - new Date(a.refill_time).getTime()),
            //     0,
            //     newResult,
            //     response.data,
            //     dispatch,
            //     (result) => {
            //         // console.log(response.data)
            //         dispatch( {
            //             type: RECEIVE_FUEL_MANAGEMENT_LIST,
            //             payload: {...response.data, result}
            //         })
            //         // console.log(response.data)
            // });

        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_FUEL_MANAGEMENT_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_FUEL_MANAGEMENT_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_FUEL_MANAGEMENT_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_FUEL_MANAGEMENT_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_FUEL_MANAGEMENT_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_FUEL_MANAGEMENT_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }